import { render, staticRenderFns } from "./PrintTypeListComponent.vue?vue&type=template&id=12f9049a&"
import script from "./PrintTypeListComponent.vue?vue&type=script&lang=js&"
export * from "./PrintTypeListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports